import { useMemo } from 'react'
import { useLocation, useParams } from 'react-router'
import ModalCEVariant from './ModalCEVariant'
import VariantSortButton from './VariantSortButton'
import VariantsValues from './VariantValues'
import { VariantModelTypeExtended } from './types'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import DoubleTable from '../../../../../../baseComponents/DoubleTable'
import { useAddDoubleTableGreenRowRender } from '../../../../../../baseComponents/DoubleTable/functions'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { EditRowNotLink, DeleteRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getBasePath } from '../../../../../../utils/globals/link'
import ModalDeleteVariant from './ModalDeleteVariant'

interface VariantsProps extends ComponentWithPermissions { }

const Variants: React.FC<VariantsProps> = ({ userPermissions }) => {
    const { VariantId } = useParams()
    return (<DoubleTable userPermissions={userPermissions} FirstChild={VariantsInner} SecondChild={VariantsValues} displaySecond={VariantId !== 'main'} />)
}


const VariantsInner: React.FC<VariantsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('variants', 'Variantes'),
        newText: t('newVariant', 'Nueva variante'),
    }
    return (
        <BaseScreenTable TableComponent={TableVariant} CreateModalComponent={ModalCEVariant} EditModalComponent={ModalCEVariant} DeleteModalComponent={ModalDeleteVariant} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableVariantProps extends TableComponentProps { }

const TableVariant: React.FC<TableVariantProps> = ({ setTableInstance, userPermissions, setOpened, tableInstance }) => {
    const { t } = useTwinTranslation()
    const { VariantId } = useParams()
    const location = useLocation()
    const basePath = getBasePath(location.pathname, 'variants')
    const { rowRenderer } = useAddDoubleTableGreenRowRender(VariantId || '')
    const columns: ColumnTableSchema<VariantModelTypeExtended> = [
        {
            id: 'order',
            dataKey: 'order',
            label: t('order', 'Orden'),
            sortable: true,
            width: 100
        },
        {
            id: 'ref_code',
            dataKey: 'ref_code',
            label: t('code', 'Código'),
            sortable: true,
            width: 100
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    const children = useMemo(() => <VariantSortButton tableInstance={tableInstance} userPermissions={userPermissions} />, [tableInstance, userPermissions])
    return (
        <TwinTableLink createRowDataLink={[basePath, ['$id']]} name='variantGroups' columns={columns} getDataFrom='/api/app/product/productVariant/getAllVariantGroups' setTableInstance={setTableInstance} rowRenderer={rowRenderer} defaultOrder={{ defaultOrderField: 'order', order: 'asc' }} hideLoadFiltersButton={true} >
            {children}
        </TwinTableLink>
    )
}


export default Variants